<template>
<main class="profile">
  <h1 class="heading-common is-btn-back"><a class="btn-back" @click="backTop"></a> {{ $t('profile.title') }}</h1>

    <!-- Container -->
    <section class="container profile-top">
      <progressbar :section="sectionData" :progress="Progress"></progressbar>


      <div class="profile-div">

        <!-- アカウント情報 -->
        <div class="profile-category">{{ $t('profile.subtitle_2') }} </div>
        <div class="profile-information">
          <div class="profile-info-body form">
            <a class="button-edit" @click="editProfile"><span class="material-icons">edit</span></a>
            <div class="form-group">
              <label class="form-label required">{{ $t('profile.displayname') }}</label>
              <div class="form-text">{{ user ? user.name : '' }}</div>
            </div>
            <div class="form-group">
              <label class="form-label required">{{ $t('profile.country') }}</label>
              <div class="form-text">{{ country ? country.name : '' }}</div>
            </div>
            <div class="form-group">
              <label class="form-label required">{{ $t('language.title') }}</label>
              <div class="form-text">{{ selectedLanguage.native }}</div>
            </div>
            <div class="form-group">
              <label class="form-label required">{{ $t('profile.address') }}</label>
              <div class="form-text">{{ user ? (user.address == 'resident') ? $t('profile.resident') : $t('profile.nonresident') : '' }}</div>
            </div>
            <hr class="mg-bottom">
            <a class="button-edit" @click="editEmail"><span class="material-icons">edit</span></a>
            <div class="form-group">
              <label class="form-label required">{{ $t('profile.email') }}</label>
              <div class="form-text">{{ user ? user.email : '' }}</div>
            </div>
            <hr class="mg-bottom">
            <a class="button-edit" @click="editPassword"><span class="material-icons">edit</span></a>
            <div class="form-group">
              <label class="form-label required">{{ $t('profile.password') }}</label>
              <div class="form-text">********</div>
            </div>
          </div>
        </div>
        
        <!-- 学習時間 -->
        <div class="profile-category">{{ $t('profile.learning_title') }} </div>
        <div class="profile-information">
          <div class="profile-info-body form">
            <div class="form-group">
              <label class="form-label required">{{ $t('profile.learning_log') }}</label>
              <div class="form-text">
              <span class="color-accent bold">{{ learning_total ? learning_total.learning.h : '' }}</span> {{ $t('profile.learning_log_unit_h') }}
              <span class="color-accent bold">{{ learning_total ? learning_total.learning.m : '' }}</span> {{ $t('profile.learning_log_unit_m') }}
              </div>
            </div>
            <div class="form-group">
              <label class="form-label required">{{ $t('profile.progress_title') }}</label>
              <div class="form-text">
              {{ learning_total ? learning_total.last_session_name : '' }}
              </div>
            </div>
            <div class="form-group">
              <button class="button button-default next" @click.prevent="leaningSituation">{{ $t('common.button.detail') }}</button>
            </div>
          </div>
        </div>
        
        
      </div>

    </section>
    <!-- /Container -->

      
    <!-- FlashMessage -->
    <FlashMessage v-if="success_message"></FlashMessage>
    <!-- /FlashMessage -->

    

</main>
</template>

<script>
  import {appName, api, countrieList} from "../../config";
  import {mapState} from 'vuex';
  import {mapGetters} from 'vuex';

  import ProgressBar from '../shared/ProgressBar.vue'

  export default {
    name: 'Profile',
    components: {
      'progressbar': ProgressBar,
    },
    props: {
      success_message: {
        type: String,
        default: '',
        required: false
      }
    },
    data () {
      return {
        user: null,
        profile: null,
        country: '',
        learning_total: null,
        countries: countrieList,
        subscribed: false,
        cancelStatus: false,
        subscription: {},
        subscription_plan: '',
        subscription_status: 'none'
      }
    },

  
    computed: {
      ...mapGetters([
        'selectedLanguage'
      ]),
      sectionData() {
        return this.$store.getters.section_data;
      },
      Progress() {
        return this.$store.getters.progress ? this.$store.getters.progress : 0;
      },
      isLoggedIn() {
        const authUser = this.$store.getters.getAuthUser;
        if(authUser) {
          return true;
        } else {
          return false;
        }
      },
    },

    created() {
      let self = this
      
      self.user = null;
      self.profile = null;
      self.learning_total = null;
      
      const authUser = this.$store.getters.getAuthUser;
      if(authUser) {
        self.user = authUser;
        self.profile = { displayname: authUser.displayname, country: authUser.country, language: authUser.language };
        
        self.user.displayname = self.profile.displayname;
        self.user.country = self.profile.country;
        self.user.language = self.profile.language;
        
        self.country = this.countries.find((countryData) => {
            return (self.profile.country && countryData.val.toLowerCase() ==  self.profile.country.toLowerCase())
        })
        
        if(authUser.subscribed) {
          this.subscribed = true;
          this.cancelStatus = false;
          
          // planや状態をセット
          if(authUser.subscription !== undefined) {
            
            this.subscription = authUser.subscription
            // plan
            if(this.subscription.plan_month) {
              this.subscription_plan = 'Monthly';
            }
            
            // trial中か利用中(recurring)
            if(this.subscription.trial || this.subscription.recurring) {
              this.cancelStatus = false;
              
              if(this.subscription.trial) {
                this.subscription_status = 'Trial';
              } else {
                this.subscription_status = 'Active';
              }
            } else {
              this.cancelStatus = true;
              
              if(this.subscription.ended || this.subscription.cancelled || this.subscription.gracePeriod) {
                this.subscription_status = 'Invalid';
                if(this.subscription.gracePeriod) {
                  this.subscription_status = 'Withdraw';
                }
              }
            }
          }
        }
      }

      axios.get(api.learningLog)
        .then((resp) => {
          self.$store.dispatch('setLearningTotal',  resp.data)
          
          self.learning_total = self.$store.getters.learning_total
        })
        .catch(err => {
          (err.response && err.response.data.error)
            ? self.setErrors(err.response.data.error)
            : self.clearErrors();
        });
        
        
      if (this.success_message && this.success_message.length) {
        this.flashMessage.show({
          status: 'error',
          title: this.success_message
        });
      }
    },

    methods: {
      backTop() {
        this.$router.push({name: 'lesson'})
      },
      editProfile() {
        this.$router.push({name: 'profile.edit'})
      },
      editEmail() {
        this.$router.push({name: 'profile.email'})
      },
      editPassword() {
        this.$router.push({name: 'profile.password'})
      },
      settings() {
        this.$router.push({name: 'profile.settings'})
      },
      leaningSituation() {
        this.$router.push({name: 'profile.situation'})
      },
      subscriptionDetail() {
        this.$router.push({name: 'profile.subscription'})
      },
      
      
      logout() {
        this.$store.dispatch('showLoading', true)
        //TODO: 消えてくれない
        // window.sessionStorage.removeItem(appName);
        axios.post(api.logout).then(() => {
          this.$store.dispatch('unsetAuthUser')
          this.$store.dispatch('unsetProfile')
          this.$store.dispatch('unsetLanguage')
          this.$store.dispatch('unsetLessons')
          this.$store.dispatch('unsetLessonData')
          this.$store.dispatch('unsetLessonContent')
          .then(() => {
            
            this.$store.dispatch('showLoading', false);
            this.$router.push({name: 'login'});
          });
        });
      },
      //TODO: 取得できなかった場合のエラー
      setErrors(errors) {
        this.$store.dispatch('showLoading', false);
        this.error.profile = errors.profile ? errors.profile[0] : null;
      },
      clearErrors() {
        this.$store.dispatch('showLoading', false);
        this.error.profile = null;
      }
    },
  }
</script>